var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 94.457031c-49.238281 0-89.300781 40.058594-89.300781 89.300781 0 49.238282 40.0625 89.296876 89.300781 89.296876s89.300781-40.058594 89.300781-89.296876c0-49.242187-40.0625-89.300781-89.300781-89.300781zm0 0",
    fill: "#ff7a28",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.160156 0-256 114.839844-256 256 0 65.3125 24.597656 124.976562 64.996094 170.253906 8.652344-37.992187 28.507812-72.65625 57.5-99.660156 20.347656-18.953125 44.15625-33.136719 69.890625-41.957031-33.4375-21.160157-55.6875-58.46875-55.6875-100.878907 0-65.785156 53.519531-119.300781 119.300781-119.300781s119.296875 53.515625 119.296875 119.300781c0 42.390626-22.230469 79.6875-55.644531 100.851563 27.875 9.546875 53.425781 25.398437 74.875 46.847656 26.207031 26.207031 44.300781 59.148438 52.457031 94.8125 40.414063-45.277343 65.015625-104.949219 65.015625-170.269531 0-141.160156-114.839844-256-256-256zm0 0",
    fill: "#ff7a28",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.101562 451.648438c44.578126 37.632812 102.128907 60.351562 164.898438 60.351562s120.320312-22.722656 164.898438-60.351562c-4.105469-37.296876-20.867188-72.261719-47.582032-98.976563-31.34375-31.34375-73.007812-48.605469-117.316406-48.605469-84.390625 0-155.738281 64.378906-164.898438 147.582032zm0 0",
    fill: "#ff7a28",
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOrange);
export default __webpack_public_path__ + "static/media/UserOrange.59bd9314a0b2cfa8c9e9dde6ceb9b3a7.svg";
export { ForwardRef as ReactComponent };